import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../../../types/auth";
import { UserRole } from "../../../types/users";
import { UserProfile } from "../../../types/userProfile";

const initialState: AuthState = {
  user: null,
  profile: null,
  roles: [],
  accessToken: null,
  isAuthenticated: false,
  pendingVerification: null,
  showWelcome: false,
};

// type PendingVerificationPayload = {
//   appUserUuid: string;
//   email: string;
//   provider?: 'google' | 'email';
// };

type SetSessionPayload = {
  appUserUuid: string;
  email: string;
  firstName: string;
  lastName: string;
  isOrgOnboarded: boolean;
  roleList: UserRole[];
  authToken: string;
  orgUuid?: string | null;
  orgSlug?: string | null;
  profileImageURL?: string | null;
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setSession(state, action: PayloadAction<SetSessionPayload>) {
      state.user = {
        appUserUuid: action.payload.appUserUuid,
        email: action.payload.email,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        orgUuid: action.payload.orgUuid ?? null,
        orgSlug: action.payload.orgSlug ?? null,
        isOrgOnboarded: action.payload.isOrgOnboarded,
        roleList: action.payload.roleList,
        profileImageURL: action.payload.profileImageURL,
      };

      state.roles = action.payload.roleList;
      state.accessToken = action.payload.authToken;
      state.isAuthenticated = true;
    },

    updateOrgUuid(state, action: PayloadAction<string>) {
      if (state.user) {
        state.user.orgUuid = action.payload;
        state.user.isOrgOnboarded = true;
      }
    },
    setShowWelcome: (state) => {
      state.showWelcome = true;
    },
    clearShowWelcome: (state) => {
      state.showWelcome = false;
    },

    setUserProfile(state, action: PayloadAction<UserProfile>) {
      state.profile = action.payload;
    },

    clearSession() {
      return initialState;
    },
    setPendingVerification(
      state,
      action: PayloadAction<{
        appUserUuid: string;
        email: string;
        provider: string;
      }>,
    ) {
      state.pendingVerification = {
        appUserUuid: action.payload.appUserUuid,
        email: action.payload.email,
        orgUuid: null,
      };
    },

    setPendingOrgUuid(state, action: PayloadAction<string>) {
      if (state.pendingVerification) {
        state.pendingVerification.orgUuid = action.payload;
      }
    },

    clearPendingVerification(state) {
      state.pendingVerification = null;
    },
  },
});

export const {
  setSession,
  clearSession,
  updateOrgUuid,
  setPendingOrgUuid,
  setPendingVerification,
  clearPendingVerification,
  setUserProfile,
  setShowWelcome,
  clearShowWelcome,
} = authSlice.actions;
export default authSlice.reducer;
